import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = ({ open, message = 'Loading Please wait...' }) => {
  if (!open) return null;

  return (
    <div className="loader-wrapper" role="alert" aria-live="polite">
      <div className="loader-container">
        <svg viewBox="0 0 260 260" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <g id="spoke">
              <line x1="130" y1="130" x2="130" y2="60" stroke="#FFD700" strokeWidth="1.5" opacity="0.6" />
              <path d="M 124,60 Q 130,42 130,35 Q 130,42 136,60 Z" fill="#FFC107" opacity="0.8" />
            </g>
          </defs>

          <g className="chakra-pulse">
            <g className="chakra-spin">
              <circle cx="130" cy="130" r="100" fill="none" stroke="#FFB300" strokeWidth="1.5" strokeDasharray="8 6" opacity="0.5" />
              <circle cx="130" cy="130" r="85" fill="none" stroke="#FF8F00" strokeWidth="2" opacity="0.4" />
              <circle cx="130" cy="130" r="30" fill="none" stroke="#FFD700" strokeWidth="1" opacity="0.6" />

              {[...Array(12)].map((_, index) => (
                <use key={index} href="#spoke" transform={`rotate(${index * 30} 130 130)`} />
              ))}

              <circle cx="130" cy="130" r="5" fill="#FFE082" />
            </g>
          </g>

          <circle cx="180" cy="200" r="40" fill="#FF9800" opacity="0.1" filter="blur(10px)" />

          <circle className="smoke s1" cx="170" cy="140" r="8" fill="#B0BEC5" />
          <circle className="smoke s2" cx="190" cy="130" r="12" fill="#CFD8DC" />
          <circle className="smoke s3" cx="180" cy="150" r="10" fill="#90A4AE" />

          <g id="priest">
            <path d="M 25,230 C 25,200 85,200 100,230 Z" fill="#E65100" />
            <path d="M 25,230 C 40,225 60,225 100,230 Z" fill="#BF360C" />
            <path d="M 45,155 L 75,155 L 85,220 L 40,220 Z" fill="#FCD5B5" />
            <path d="M 42,152 C 60,145 85,155 85,170 L 60,228 L 30,220 Z" fill="#F8F9FA" />
            <path d="M 55,152 C 65,170 65,205 48,225" stroke="#E0E0E0" strokeWidth="1.5" fill="none" strokeLinecap="round" />
            <path d="M 68,158 C 75,180 75,210 58,228" stroke="#E0E0E0" strokeWidth="1.5" fill="none" strokeLinecap="round" />
            <path d="M 42,152 C 60,145 85,155 85,170 L 60,228" stroke="#FFD700" strokeWidth="2.5" fill="none" strokeLinecap="round" />
            <path d="M 45,150 C 60,143 83,153 83,168 L 58,226" stroke="#FFA000" strokeWidth="1" fill="none" strokeLinecap="round" />
            <path d="M 55,145 L 65,145 L 65,160 L 55,160 Z" fill="#FCD5B5" />
            <ellipse cx="60" cy="128" rx="14" ry="17" fill="#FCD5B5" />
            <path d="M 50,112 C 40,118 42,132 50,126" stroke="#212121" strokeWidth="2.5" fill="none" strokeLinecap="round" />
            <path d="M 73,125 L 79,129 L 73,133 Z" fill="#FCD5B5" />
            <path d="M 73,133 C 75,135 75,138 71,139" stroke="#E6A87C" strokeWidth="1" fill="none" />
            <path d="M 63,125 Q 68,127 70,125" stroke="#8D6E63" strokeWidth="1.5" fill="none" strokeLinecap="round" />
            <line x1="68" y1="118" x2="72" y2="118" stroke="#D32F2F" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="69" y1="121" x2="73" y2="121" stroke="#D32F2F" strokeWidth="1.5" strokeLinecap="round" />
          </g>

          <g className="arm-movement">
            <path d="M 60,155 Q 100,175 130,170" stroke="#FCD5B5" strokeWidth="7" strokeLinecap="round" fill="none" />
            <circle cx="130" cy="170" r="4.5" fill="#E6A87C" />
            <g className="ladle-tilt">
              <line x1="130" y1="170" x2="168" y2="158" stroke="#FFD700" strokeWidth="2.5" strokeLinecap="round" />
              <path d="M 168,158 C 168,166 178,166 178,158 Z" fill="#FFC107" />
              <path d="M 170,158 C 170,163 176,163 176,158 Z" fill="#FF9800" />
            </g>
          </g>

          <path className="ghee-drop" d="M 174,163 C 172,168 176,168 174,163 Z" fill="#FFF59D" stroke="#FFEB3B" strokeWidth="2" strokeLinecap="round" />

          <g id="kund">
            <polygon points="155,245 205,245 195,255 165,255" fill="#5D1E04" />
            <polygon points="140,225 220,225 210,245 150,245" fill="#8D2400" />
            <polygon points="140,225 220,225 218,230 142,230" fill="#6A1A00" />
            <polygon points="120,210 240,210 230,225 130,225" fill="#BF360C" />
            <polygon points="120,210 240,210 238,214 122,214" fill="#E64A19" />
            <path d="M 125,215 C 105,215 105,235 135,230" stroke="#E64A19" strokeWidth="3" fill="none" strokeLinecap="round" />
            <path d="M 235,215 C 255,215 255,235 225,230" stroke="#E64A19" strokeWidth="3" fill="none" strokeLinecap="round" />
            <rect x="175" y="213" width="10" height="10" transform="rotate(45 180 218)" fill="#FFD700" />
            <rect x="145" y="213" width="8" height="8" transform="rotate(45 149 217)" fill="#FFD700" />
            <rect x="207" y="213" width="8" height="8" transform="rotate(45 211 217)" fill="#FFD700" />
          </g>

          <g id="samidha">
            <ellipse cx="180" cy="210" rx="35" ry="8" fill="#FF5722" filter="blur(2px)" />
            <polygon points="145,205 150,200 200,205 195,212" fill="#4E342E" />
            <polygon points="150,200 155,202 200,205 195,203" fill="#3E2723" />
            <polygon points="215,202 210,198 155,206 160,211" fill="#5D4037" />
            <polygon points="210,198 207,200 155,206 157,204" fill="#3E2723" />
          </g>

          <g className="flame-group">
            <path className="flicker-1" d="M 180,212 C 145,212 130,175 155,145 C 160,135 170,150 175,130 C 180,105 190,135 195,145 C 220,185 205,212 180,212 Z" fill="#E64A19" />
            <path className="flicker-2" d="M 180,212 C 155,212 145,185 165,165 C 170,155 175,170 178,145 C 182,125 188,155 192,165 C 210,195 195,212 180,212 Z" fill="#FF9800" />
            <path className="flicker-3" d="M 180,212 C 165,212 160,195 172,175 C 175,168 178,180 180,160 C 182,145 186,170 188,175 C 198,195 190,212 180,212 Z" fill="#FFEB3B" />
            <path className="flicker-1" d="M 180,210 Q 170,195 180,180 Q 190,195 180,210 Z" fill="#FFF9C4" />
          </g>

          <g id="sparks">
            <circle className="spark sp-1" style={{ '--tx': '-25px' }} cx="170" cy="190" r="1.5" fill="#FFEB3B" />
            <circle className="spark sp-2" style={{ '--tx': '35px' }} cx="190" cy="195" r="2" fill="#FF9800" />
            <circle className="spark sp-3" style={{ '--tx': '-15px' }} cx="175" cy="180" r="1.2" fill="#FFF" />
            <circle className="spark sp-4" style={{ '--tx': '25px' }} cx="185" cy="185" r="1.5" fill="#FFC107" />
          </g>

          <polygon points="120,210 240,210 236,213 124,213" fill="#8D2400" opacity="0.9" />
        </svg>
      </div>
      <div className="loading-text">{message}</div>
    </div>
  );
};

export default LoadingOverlay;
